import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Likes = () => {
  const { addToCart } = useCart();

  // 模拟收藏的产品数据
  const likedProducts = [
    {
      id: '1',
      name: 'Nintendo Joycon Pikachu',
      price: 'S$45.90',
      originalPrice: 'S$59.90',
      image: '/images/shop-products/nintendo-joycon-pikachu/main.jpg',
      category: 'Gaming',
      rating: 4.8,
      reviews: 124
    },
    {
      id: '2',
      name: 'Wireless Keyboard',
      price: 'S$44.00',
      image: '/images/shop-products/wireless-keyboard/main.jpg',
      category: 'Accessories',
      rating: 4.6,
      reviews: 89
    },
    {
      id: '3',
      name: 'Karaoke Speaker',
      price: 'S$67.50',
      image: '/images/shop-products/karaoke-speaker/main.jpg',
      category: 'Audio',
      rating: 4.9,
      reviews: 156
    }
  ];

  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
  };

  const handleRemoveLike = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    // 这里可以添加移除收藏的逻辑
    console.log('Remove from likes:', productId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 pb-20">
      <div className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl font-bold text-white mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          My Likes
        </motion.h1>

        {likedProducts.length === 0 ? (
          <motion.div 
            className="text-center py-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <div className="text-gray-400 text-6xl mb-4">❤️</div>
            <h3 className="text-xl text-white mb-2">No liked items yet</h3>
            <p className="text-gray-400">Start exploring products and add them to your likes</p>
          </motion.div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {likedProducts.map((product, index) => (
              <motion.div
                key={product.id}
                className="group bg-gray-800 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link to={`/product/${product.id}`}>
                  <div className="p-3">
                    {/* Product Image */}
                    <div className="relative mb-3 overflow-hidden rounded-lg bg-gray-700">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full aspect-square object-cover object-center group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                          e.target.src = '/images/products/placeholder.jpg';
                        }}
                      />
                      
                      {/* Remove from likes button */}
                      <button
                        onClick={(e) => handleRemoveLike(e, product.id)}
                        className="absolute top-2 right-2 bg-red-600 text-white p-1.5 rounded-full hover:bg-red-700 transition-colors"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>

                    {/* Product Info */}
                    <div className="space-y-2">
                      {/* Category */}
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">
                          {product.category}
                        </span>
                        {/* Rating */}
                        <div className="flex items-center space-x-1">
                          <span className="text-yellow-400 text-xs">★</span>
                          <span className="text-xs font-medium text-white">{product.rating}</span>
                          <span className="text-xs text-gray-400">({product.reviews})</span>
                        </div>
                      </div>

                      {/* Product Name */}
                      <h3 className="text-sm font-bold text-white group-hover:text-green-400 transition-colors duration-200 leading-tight line-clamp-2">
                        {product.name}
                      </h3>

                      {/* Price Section */}
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-1">
                          <span className="text-sm font-bold text-white">
                            {product.price}
                          </span>
                          {product.originalPrice && (
                            <span className="text-xs text-gray-400 line-through">
                              {product.originalPrice}
                            </span>
                          )}
                        </div>
                      </div>
                      
                      {/* Add to Cart Button */}
                      <button
                        onClick={(e) => handleAddToCart(e, product)}
                        className="w-full py-1.5 bg-green-600 hover:bg-green-700 text-white rounded text-xs font-medium transition-all duration-200"
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Likes;
